const zh = {
  code: "zh",
  htmlLang: "zh-CN",
  meta: {
    title: "在需要之前，先选择替您作主的人 | 免费持久授权书（LPA）线上讲座",
    description: "参加专为新加坡家庭而设的免费华语线上讲座，了解持久授权书（LPA）的作用、如何选择受权人、授权范围、OPGO 办理流程，以及没有 LPA 时家人会面对什么。",
  },
  brand: { name: "AFFINITY", small: "Infinity Financial Advisory 旗下财务顾问代表团队" },
  closed: {
    chip: "报名已截止 · 新日期即将公布",
    badge: "报名已截止",
    title: "新一轮讲座日期即将公布。",
    message:
      "持久授权书（LPA）线上讲座的报名目前已截止。新日期将很快公布——请留意最新消息，或在下方留下您的电邮，新场次开放报名时我们会第一时间通知您。",
    sessionsNote: "报名目前已截止，新日期将很快公布——请留意最新消息。",
    cta: "获取日期通知",
    notify: {
      label: "电邮地址",
      placeholder: "输入您的电邮以获取新日期通知",
      button: "有新日期时通知我",
      success: "谢谢您——新日期一公布，我们会立即发送电邮通知您。",
      error: "暂时无法为您登记，请稍后再试。",
      invalid: "请输入有效的电邮地址。",
    },
  },
  nav: { context: "免费 · Zoom 线上直播 · 新加坡家庭适用", reserve: "立即保留席位", langLabel: "选择页面语言" },
  hero: {
    chip: "{count}场 Zoom 线上直播讲座 · 英文 {en} · 华语 {zh} · 上午10时至11时 · 免费参加",
    title: ["如果有一天，您无法再替自己作决定，", "您会信任谁来代表您？"],
    lead: "中风、意外或失智，可能在一天之内剥夺您作决定的能力。持久授权书让您信任的人能立即代您行事，而不是让家人花上数月时间与律师费申请法庭命令，而您的账户、账单与照护却在等待。",
    benefits: ["看懂 LPA 能做什么，不能做什么", "有把握地选择合适的受权人", "带走从决定到注册的实际步骤"],
    quickLabel: "电邮地址",
    quickPlaceholder: "输入电邮，保留席位",
    quickButton: "保留我的免费席位",
    learnLink: "看看没有 LPA 的家庭会面对什么 ↓",
    micros: ["免费参加", "60分钟 · Zoom 直播", "无推销 · 无任何购买义务"],
    formatNote: "所有场次均为 Zoom 线上直播讲座，在家用手机、平板或电脑即可参加，并非实体活动。",
    presenterInitials: "VC",
    presenter: "华语主讲：Vincent Chua 蔡镇安 · 资深财务顾问经理，代表 Infinity Financial Advisory",
  },
  reflection: {
    questionIds: ["without", "unsure"],
    kicker: "一个值得认真回答的问题",
    title: "如果您失去心智能力，配偶或子女能自动替您处理一切吗？",
    options: ["能，我相信可以", "我其实不太确定"],
    prompt: "请选择最贴近您现况的答案。",
    answers: [
      "大多数人都这么认为。但在新加坡，配偶或子女的身份本身并不赋予他们处理您银行账户、房产或照护决定的法定权力。没有 LPA，家人可能需要先向法庭申请成为您的代理人。",
      "这份诚实的不确定，正是大多数家庭的起点。一个小时后，您将知道谁能合法代您行事、他们能决定什么，以及如何在需要之前把合适的人安排到位。",
    ],
    link: "了解家人实际上拥有的法定权力 →",
  },
  credibility: [
    { icon: "SG", text: "新加坡专属：《心智能力法令》、OPGO 与认证人一次讲清" },
    { icon: "1H", text: "一小时掌握重点，浅白易懂，拒绝法律术语" },
    { icon: "Q", text: "真实情境解析 + 现场问答，欢迎带上家人的疑问" },
  ],
  marquee: ["持久授权书", "选择受权人", "心智能力法令", "个人福利", "财产与事务", "OPGO 线上申请", "法庭代理人", "新加坡家庭适用", "免费线上讲座"],
  clarity: {
    eyebrow: "权力的空缺",
    title: "爱，并不会自动变成法定权力。",
    lead: "没有持久授权书，即使是您最亲近的人，也可能需要先向法庭申请，才能代您行事。提早规划，意味着由您，而不是法庭，来决定谁代表您，以及他们能决定什么。",
    button: "填补我的权力空缺",
    mapKicker: "点击每一个关键点",
    mapTitle: "塑造您 LPA 的四个决定。",
    interactive: "互动体验",
    maps: [
      { title: "您信任谁？", meta: "价值观 · 判断力 · 可靠性", message: "谁具备判断力、可靠性，并真正理解您的价值观，能以您的最佳利益行事？在需要时，他们会在身边吗？", question: "donee" },
      { title: "他们能决定什么？", meta: "福利 · 财产 · 事务", message: "受权人应该处理您的个人福利、财产与事务，还是两者兼备？两者涉及的照护与金钱决定截然不同。", question: "what" },
      { title: "他们如何行事？", meta: "一位受权人 · 多位受权人", message: "如果您委任不止一位受权人，他们应该共同决定，还是可以各自行事？您是否已指定替代受权人，以备其中一人无法履行？", question: "donee" },
      { title: "如何完成办理？", meta: "OPGO · 接受委任 · 认证", message: "您是否了解线上申请、受权人接受委任与认证人认证这三个步骤，才能让 LPA 注册并真正可用？", question: "without" },
    ],
  },
  plan: {
    eyebrow: "把 LPA 讲清楚",
    title: "它不只是一份表格，而是一连串重要的选择。",
    lead: "逐一探索五大要点，把“我知道应该办”的模糊想法，变成一份家人看得懂、关键时刻真正用得上的持久授权书。",
    tabs: [
      {
        label: "为什么", panelLabel: "为什么重要", title: "最亲近的人，也可能无法代您行事。",
        copy: "如果您在没有 LPA 的情况下失去心智能力，家人并不会自动获得处理您事务的法定权力。他们可能需要向法庭申请成为您的代理人，在本已艰难的时刻增添时间、费用与压力，而且由法庭而非您来决定人选。",
        source: "官方参考：公众监护人办公处（OPG）", href: "https://www.msf.gov.sg/what-we-do/opg/lasting-power-of-attorney/why-make-a-lasting-power-of-attorney",
        prompt: "如果危机明天发生，谁能合法地代您行事？",
      },
      {
        label: "人", panelLabel: "您信任的决策者", title: "当您无法开口时，谁应该替您发声？",
        copy: "LPA 让年满 21 岁的授权人（Donor）委任一位或多位受权人（Donee），在授权人日后失去心智能力时代为决定。选得好，靠的是信任、能力、时间与对您价值观的真正理解，而不单是关系最近的那一位。",
        source: "官方参考：公众监护人办公处（OPG）", href: "https://www.msf.gov.sg/what-we-do/opg/lasting-power-of-attorney/what-is-a-lasting-power-of-attorney",
        prompt: "谁能保持冷静、以您的最佳利益行事，并负责任地处理困难的对话？",
      },
      {
        label: "权力", panelLabel: "您的选择", title: "个人福利、财产与事务，还是两者兼备？",
        copy: "由您决定受权人可以行事的范围：个人福利事务（居住安排、日常照护、医疗决定）、财产与事务（银行账户、账单、房产、投资），或两者兼备。理解其中的分别，才能授予真正符合您需要的权力。",
        source: "官方参考：公众监护人办公处（OPG）", href: "https://www.msf.gov.sg/what-we-do/opg/lasting-power-of-attorney/what-is-a-lasting-power-of-attorney",
        prompt: "您的照护与财务生活中，哪些部分需要由您选定的人来处理？",
      },
      {
        label: "流程", panelLabel: "您的申请", title: "从决定到提交，三个清晰阶段。",
        copy: "目前的流程从使用 Singpass 在 OPGO 线上申请开始。受权人审阅并接受委任后，由获授权的认证人（Certificate Issuer）见证及认证，再提交公众监护人办公处注册。",
        source: "官方指南：如何办理 LPA", href: "https://www.msf.gov.sg/what-we-do/opg/lasting-power-of-attorney/how-to-make-a-lasting-power-of-attorney",
        prompt: "在开始线上申请之前，您知道需要先决定哪些事项吗？",
      },
      {
        label: "使用", panelLabel: "何时生效", title: "LPA 不是今天就交出控制权。",
        copy: "只有在注册医生证实您已失去心智能力之后，受权人才能根据 LPA 代您行事。在此之前，每一个决定仍由您作主。电子版 LPA 可通过 OPGO 与银行、医院及其他机构共享。",
        source: "官方指南：使用 LPA", href: "https://www.msf.gov.sg/what-we-do/opg/lasting-power-of-attorney/using-a-lasting-power-of-attorney",
        prompt: "您的受权人是否理解这个角色所带来的权力与责任？",
      },
    ],
    askYourself: "问问自己：",
  },
  beliefs: {
    eyebrow: "常见的想法",
    title: "哪一句最像您？",
    lead: "点选一句。如果它听起来很熟悉，这场讲座正是为了把这个想法变成清晰可行的下一步。",
    assumption: "想法",
    items: [
      { short: "“我还年轻。”", title: "“我还年轻，LPA 可以以后再说。”", copy: "失去心智能力不只与年老有关。意外与突发疾病可能发生在任何年龄，这正是为什么 LPA 从 21 岁起就可以办理。一旦失去心智能力，就再也无法办理。" },
      { short: "“配偶可以代办。”", title: "“我的配偶自然可以处理一切。”", copy: "配偶或子女的身份，并不自动赋予他们处理您照护、银行、房产或其他事务的法定权力。银行与医院需要法律依据才能接受指示；没有 LPA，通常就意味着要向法庭申请。" },
      { short: "“我会失去控制权。”", title: "“办了 LPA，我现在就要交出控制权。”", copy: "办理 LPA 并不代表在您仍有心智能力时交出控制权。受权人只有在您被医生证实失去心智能力之后，才能根据 LPA 行事。在此之前，一切仍由您全权作主。" },
      { short: "“听起来很复杂。”", title: "“办理 LPA 听起来太复杂了。”", copy: "流程分为三个清晰阶段：通过 OPGO 完成申请，由受权人接受委任，再与获授权的认证人会面完成认证。事前知道要决定什么，就是让它变简单的关键。" },
    ],
  },
  scenario: {
    eyebrow: "接下来会发生什么？",
    title: "两个家庭，同一场变故，截然不同的几个月。",
    lead: "选择一个真实情境，比较您的家人在有与没有注册 LPA 的情况下，将面对什么。仅作说明，但每一步都反映了新加坡的一般实际流程。",
    pickerLabel: "选择情境",
    withoutHeading: "没有 LPA",
    withoutBadge: "法庭决定",
    withHeading: "有已注册的 LPA",
    withBadge: "由您决定",
    footerStrong: "变故发生之后，就再也无法办理 LPA。",
    footerCopy: "它必须在您仍有心智能力时签署。所以，了解该决定什么的最好时机，就是所有选择仍在您手中的现在。",
    button: "保留我的免费席位",
    note: "以上情境为简化的教育性说明，不构成法律建议；实际时间因个案而异。",
    items: [
      {
        icon: "52", label: "52岁中风", contextLabel: "情境：", context: "一位父亲在工作时突然倒下。他活了下来，但医生证实他已无法自己作决定。房贷、账单与住院照护，都需要有人出面处理。",
        question: "without",
        without: [
          { title: "账户被冻结", copy: "银行无法接受太太的指示。联名账户稍有帮助，个人账户则完全动不了。" },
          { title: "家人向法庭申请", copy: "太太职请律师，根据《心智能力法令》申请成为代理人。" },
          { title: "数月的等待与费用", copy: "医疗报告、宣誓书与庭审，而照护费与房贷仍在到期。" },
          { title: "由法庭选人", copy: "法官决定由谁担任代理人以及权力范围，家人只能遵从法庭命令。" },
        ],
        withoutOutcome: "数月的不确定、律师费，以及由外人作出的决定，而这正是这个家庭最艰难的几个星期。",
        with: [
          { title: "确认失去心智能力", copy: "注册医生证实他已失去心智能力。" },
          { title: "受权人立即接手", copy: "他多年前选定的太太，通过 OPGO 出示已注册的 LPA。" },
          { title: "账单与照护照常进行", copy: "银行、保险公司与医院在他授予的权力范围内，按受权人的指示行事。" },
          { title: "他的意愿主导一切", copy: "关于照护与金钱的决定，都遵循他在健康时作出的选择。" },
        ],
        withOutcome: "几天之内就能延续一切：由他信任的人，行使他选定的权力。",
      },
      {
        icon: "38", label: "38岁遇上意外", contextLabel: "情境：", context: "一位年轻母亲在车祸中严重受伤，数月无法沟通。她的薪水停了，家庭开支却没有停。",
        question: "without",
        without: [
          { title: "“她还年轻，我们从没想过”", copy: "没有 LPA。先生以为自己可以处理她的事务，结果发现不行。" },
          { title: "保险理赔停滞", copy: "赔付指示与保单变更，都需要她的签名或一位合法授权的人。" },
          { title: "申请法庭代理人", copy: "在照顾她与孩子的同时，还要应对律师费与法庭程序。" },
          { title: "权力有限且姍来", copy: "即使获批，法庭命令也未必涵盖家庭所需的一切。" },
        ],
        withoutOutcome: "一个年轻家庭背负着法律程序与费用，而他们的心力本应放在别处。",
        with: [
          { title: "她早已选好人", copy: "35岁时，她委任先生为受权人，姐姐为替代受权人。" },
          { title: "权力立即生效", copy: "一经证实失去心智能力，已注册的 LPA 获银行与保险公司认可。" },
          { title: "专心康复，而非文件", copy: "先生专注于她的康复与孩子，财务照常运作。" },
          { title: "她重新掌握一切", copy: "当她恢复心智能力，所有决定重新回到她手中；LPA 只是随时待命。" },
        ],
        withOutcome: "35岁时的一个决定，在 38 岁时保护了整个家庭。",
      },
      {
        icon: "71", label: "71岁确诊失智", contextLabel: "情境：", context: "母亲的记忆力逐年退化。今年，医生证实她已无法安全地管理财务或作出照护决定。",
        question: "family",
        without: [
          { title: "已来不及办理 LPA", copy: "LPA 必须在她仍有心智能力时办理，这个窗口已经关闭。" },
          { title: "兄弟姐妹意见不合", copy: "谁来管她的存款？她应该住在哪里？没有人拥有决定的权力。" },
          { title: "向法庭申请", copy: "其中一位子女申请成为代理人，其他子女必须获通知，也可能提出反对。" },
          { title: "长期向法庭汇报", copy: "代理人必须向法庭交代，多年的行政负担随之而来。" },
        ],
        withoutOutcome: "家庭矛盾、法律费用与法庭程序，恰好发生在她最需要照护的时刻。",
        with: [
          { title: "在健康时就已规划", copy: "多年前，她选定了最信任的子女，并告诉家人原因。" },
          { title: "照护决定清晰明确", copy: "受权人在她授予的权力范围内，按她的意愿安排照护与财务。" },
          { title: "不用上法庭，也没有争执", copy: "她的选择已白纸黑字注册，争议在开始之前就已化解。" },
          { title: "尊严得以保全", copy: "她选定的人替她发声，一如她所愿。" },
        ],
        withOutcome: "她的声音仍在主导，通过她选定的人。趁父母还能选择时，帮他们作出这个决定。",
      },
    ],
  },
  journey: {
    eyebrow: "您的 LPA 路线图",
    title: "四个决定，一条更清晰的路。",
    lead: "讲座带您从“我知道应该办 LPA”，走到“我知道该选谁、该决定什么、该从哪里开始”。",
    duration: "Zoom 线上直播 · 60 分钟 · 全程线上",
    takeaway: "您的收获",
    steps: [
      { title: "看见空缺", copy: "了解当没有人被正式委任时，会发生什么。", outcome: "理解 LPA 所提供的保障。", detail: "了解 LPA 的作用、何时可用、它与遗嘱及法庭代理人命令的分别，以及为什么家人关系本身并不构成法定权力。" },
      { title: "选对的人", copy: "辨识选择一位或多位受权人时真正重要的特质。", outcome: "因为对的理由选择受权人。", detail: "在邀请任何人承担这份责任之前，先考虑信任、判断力、时间与家庭关系，并了解何时需要替代受权人。" },
      { title: "定义权力", copy: "理解两大决策范围，以及多位受权人的行事方式。", outcome: "让授权范围符合您想涵盖的决定。", detail: "分清个人福利决定与财产与事务决定，并理解共同行事与共同及各自行事的分别。" },
      { title: "掌握流程", copy: "从 Singpass 登录到认证，看懂完整申请路程。", outcome: "带着迈出第一步的实际方法离开。", detail: "逐步了解目前的 OPGO 申请、受权人接受委任与认证人认证阶段，知道开始前该准备什么。" },
    ],
    outcomes: [
      { value: "60分钟", label: "一小时 Zoom 直播，并预留时间回答您的问题" },
      { value: "4", label: "讲座结束时，您将能清晰作出的四个决定" },
      { value: "1", label: "从决定到注册的逐步清单" },
      { value: "$0", label: "完全免费。没有产品推销，也没有任何后续义务" },
    ],
  },
  video: {
    eyebrow: "一段值得听见的话",
    title: "一个小时，可能省下数月的不确定。",
    lead: "LPA 是一个在您还能作决定时作出的决定，让您信任的人不必在危机中四处争取权力。",
    note: "以下为过往持久授权书实体讲座的精彩回顾与学员分享。线上讲座内容与实体讲座相同，通过 Zoom 直播。",
    points: [
      "家人实际上自动拥有与不拥有的法定权力",
      "如何思考受权人与您可授予的权力",
      "目前的线上申请、接受委任与认证流程",
    ],
    button: "参加下一场直播",
    caption: "持久授权书 · 过往实体讲座回顾",
    quotesTitle: "学员心声",
    quotes: [
      { text: "我一直以为万一有事，太太自然可以替我处理。听完才知道没有 LPA 她得先申请法庭命令，这是我们全家最需要的一记提醒。", who: "学员 · 2025年实体讲座" },
      { text: "讲解清楚、务实，没有难懂的术语。受权人、个人福利与财产事务的分别、OPGO 的步骤，连我父母都听得明白。", who: "学员 · 2025年实体讲座" },
      { text: "本来是为自己而来，结果也为母亲理出了一套计划。知道该委任谁、该从哪里开始，全家人都放下了一块大石。", who: "学员 · 2025年实体讲座" },
    ],
  },
  readiness: {
    eyebrow: "60秒自我检视",
    title: "您的 LPA 准备好了多少？",
    lead: "勾选今天能肯定地说“是”的句子。这是一个反思工具，而非法律或财务评估。",
    checks: [
      "我了解 LPA 涵盖什么，以及何时可以使用。",
      "我已决定信任谁作为受权人（以及替代受权人）。",
      "我知道自己想授予哪些决策权力。",
      "我打算委任的人理解并愿意承担这份责任。",
      "我了解线上申请与认证的各个阶段。",
    ],
    confident: "肯定属实",
    scoreOf: "项已清晰（共5项）",
    scoreNote: "仅作教育性反思 · 不会保存任何资料",
    button: "保留我的免费席位",
    prefill: ["unsure", "donee", "combine"],
    scores: [
      ["还有几个重要的决定尚未清晰。", "您不需要先有所有答案才来参加。讲座会帮您看清应该先决定什么，以及先后顺序。"],
      ["很有价值的第一步。", "您已经开始思考。讲座会帮您把这个念头，变成谁来行事、如何行事的具体计划。"],
      ["部分基础已经到位。", "接下来可检视您心中的人选与权力范围，是否仍符合家庭与您的意愿。"],
      ["您正在建立真正的保障。", "您的思路很有条理。用这场讲座检验您的选择，并完整掌握流程。"],
      ["准备程度相当完善。", "即使准备充分，经历人生重大变化后也应重新检视受权人与权力范围。欢迎带上具体问题到现场问答。"],
      ["您已考虑到所有关键环节。", "把这场讲座当作一次实用复盘，也帮父母、配偶或兄弟姐妹开始他们的 LPA 之旅。"],
    ],
  },
  speaker: {
    eyebrow: "华语主讲人",
    title: "复杂的法律安排，也可以讲得清楚易懂。",
    lead: "由兼具专业资格、实战经验与家庭视角的讲者主讲，引导您看见真正重要的规划问题。",
    sessionSuffix: { one: "场", many: "场" },
    people: [
      {
        id: "vincent",
        tag: "华语讲座主讲人",
        name: "Vincent Chua 蔡镇安 | CFP®, ChFC®",
        role: "资深财务顾问经理，代表 Infinity Financial Advisory",
        rnf: "RNF: CTA300278121",
        initials: "VC",
        portrait: "/speaker-vincent.jpg",
        portraitFit: "portrait-cover",
        bio: "蔡镇安是一位兼具专业深度与实战经验的资深财务顾问经理，拥有近十年财务规划经验，并持有新加坡注册财务规划师（CFP®）及特许财务顾问（ChFC®）资格。他擅长以清晰、务实且贴近生活的方式，协助家庭理解持久授权书、遗嘱、CPF 提名与保险如何构成一套完整的保障安排，让照护与财务决定始终掌握在信任的人手中。",
        focus: ["LPA 要点", "选择受权人", "决策权力", "申请路线图"],
      },
    ],
  },
  mid: { title: "选择由谁代您行事的最好时机，就是每一个选择仍在您手中的现在。", button: "保留我的免费席位" },
  sessions: {
    eyebrow: "选择您的线上讲座场次",
    title: "选择适合您的日期与语言。",
    lead: "所有场次均为免费 Zoom 线上直播，时长约一小时（新加坡时间上午10时至11时）。英文场由 Nicholas Lee 主讲；华语场由 Vincent Chua 蔡镇安主讲。每场 Zoom 席位有限。",
    englishGroup: "英文场 · Nicholas Lee",
    chineseGroup: "华语场 · Vincent Chua 蔡镇安",
    time: "上午10时 – 11时（新加坡时间）",
    reserve: "预留此场次",
    format: "Zoom 线上直播讲座 · 任何地点均可参加",
  },
  faq: {
    eyebrow: "报名之前还有疑问？",
    title: "从这里开始。",
    lead: "如果这里没有您的问题，欢迎先保留席位，并在现场问答环节提出。",
    items: [
      { q: "这是实体讲座还是线上讲座？", a: "这是 100% 线上讲座，通过 Zoom 直播，没有实体场地，也无需出门。您可在家中或新加坡任何地点，用手机、平板或电脑参加。报名后，您的专属 Zoom 参加链接会发送到您的电邮，讲座前一天也会再次发送提醒。" },
      { q: "这场讲座只适合年长人士吗？", a: "不是。年满 21 岁、仍有心智能力的成年人都可以办理 LPA。意外与突发疾病可能发生在任何年龄，因此这个课题远在年老之前就已相关；许多学员也是为了年长父母而参加。" },
      { q: "我的配偶或子女能自动代我行事吗？", a: "未必。家人关系本身并不自动赋予他们处理您所有个人福利、银行、房产或其他事务的权力。没有 LPA，可能需要向法庭申请成为代理人。" },
      { q: "LPA 与遗嘱有什么分别？", a: "LPA 关乎您在生但失去心智能力时，由他人代您作出的决定；遗嘱则一般关乎您身后遗产的处理。两者用途不同，大多数家庭两者都需要。" },
      { q: "我可以替父母办理 LPA 吗？", a: "每个人都必须在仍有心智能力时亲自办理，无法由他人代办。不过，您可以协助父母了解流程，并被委任为他们的受权人。讲座会说明如何开启这场对话。" },
      { q: "讲座会提供个人法律或财务建议吗？", a: "不会。讲座提供的是一般教育资讯。采取任何行动前，您仍应根据个人情况寻求独立的法律、财务或医疗专业意见。" },
      { q: "我会如何收到线上讲座链接？", a: "报名后，确认与参加方式将发送到您提供的电邮地址，并附上日历邀请。如果没有收到，请检查垃圾邮件或促销邮件文件夹。" },
    ],
  },
  register: {
    eyebrow: "保留您的席位",
    title: ["在危机开口之前，", "先选定替您发声的人。"],
    lead: "参加免费线上直播讲座，了解在新加坡办理 LPA 所涉及的人选、权力与实际步骤。三项资料，一个受用的小时。",
    chooseDate: "选择日期",
    dateLabel: "日期",
    timeLabel: "时间",
    venueLabel: "方式",
    time: "上午10时 – 11时（新加坡时间）",
    venue: "Zoom 线上直播（非实体活动）",
    speakerLabel: "主讲",
    langTag: { English: "英文场", Chinese: "华语场" },
    countdown: ["天", "小时", "分钟", "秒"],
    steps: ["保留席位", "补充资料"],
    labels: { name: "姓名", email: "电邮地址", mobile: "手机号码", session: "选择场次", question: "您最想了解的持久授权书问题", invitedBy: "邀请人", ageRange: "您的年龄段" },
    ageRanges: { under30: "30岁以下", "30s": "30 – 39岁", "40s": "40 – 49岁", "50s": "50 – 59岁", "60plus": "60岁及以上" },
    placeholders: { name: "例如：陈伟明", email: "you@example.com", mobile: "8123 4567", other: "点选上方主题，或输入您自己的问题", invitedBy: "邀请您参加的人的姓名" },
    mobilePrefix: "+65",
    optional: "（可选）",
    invitedByLocked: "已根据您顾问的邀请链接自动填入。",
    continue: "继续",
    back: "返回",
    privacyNote: "提交此表格即表示您同意我们就您的报名及活动资讯与您联系。",
    questions: {
      what: "了解什么是持久授权书，以及我是否需要",
      donee: "选择并委任合适的受权人",
      without: "没有持久授权书而失去心智能力会怎样",
      family: "为父母或配偶办理持久授权书",
      combine: "持久授权书如何与遗嘱、CPF 提名及保险配合",
      unsure: "我不确定该从哪里开始",
      other: "其他",
    },
    consent: "我已阅读上述声明，并同意 Affinity Group 为所述目的收集及使用我的个人资料。",
    pdpa: {
      intro: "当您向我们提供个人资料（即姓名、电邮地址及电话号码），即表示您确认并同意我们为以下目的收集您的个人资料：",
      purposes: [
        "通过电话、短信或电邮向您发送与本网站内容相关的营销、广告或推广资讯；",
        "提供您所要求的产品与服务。",
      ],
      withdraw: "请注意，您有权随时撤回对我们收集您个人资料的同意，只需发送通知至 ",
      email: "marketing@affinitygroup.sg",
    },
    submit: "保留我的免费席位",
    reassurance: "免费参加 · 无任何购买义务 · 您的资料将被保密",
    messages: {
      required: "请先填写所有必填项目。",
      mobile: "请输入有效的8位新加坡手机号码。",
      email: "请输入有效的电邮地址。",
      consent: "请勾选同意选项以继续。",
      ageRange: "请选择您的年龄段。",
      submitting: "正在为您保留席位…",
      success: "您的席位已保留。请查看电邮中的确认与参加详情。",
      duplicate: "此电邮已报名所选场次，期待与您相见！",
      failed: "暂时无法完成报名，请重试或联系 Affinity Group 团队。",
    },
    successHeading: "您的席位已保留。",
    successMeta: "附有日历邀请的确认电邮已发出。您的专属 Zoom 链接将在讲座前通过电邮发送。",
    another: "为他人报名",
    share: {
      kicker: "身边有人也需要了解这些吗？父母、兄弟姐妹、配偶？",
      button: "通过 WhatsApp 分享",
      message: "您好！我刚报名了 Affinity Group 主办的免费《持久授权书（LPA）》线上讲座（{date}，{time}，Zoom 直播），讲解万一发生意外，谁能合法代我们作决定。觉得对您也会有帮助，欢迎一起参加，报名链接：{url}",
    },
    calendar: {
      heading: "加入您的日历",
      title: "持久授权书（LPA）线上讲座 · Affinity Group",
      details: "您已成功报名参加 Affinity Group 的《持久授权书（LPA）》免费线上讲座（上午10时 – 11时 新加坡时间，Zoom 线上直播）。Zoom 参加链接将在讲座前通过电邮发送给您。",
      google: "Google",
      apple: "Apple / iCal",
      outlook: "Outlook",
    },
  },
  footer: {
    links: ["隐私政策", "使用条款", "常见问题"],
    blurb: "协助个人与家庭更清楚地了解自身的保障、长期护理与财务规划需求。",
    connect: "关注我们",
    quickLinksTitle: "快速链接",
    quickLinks: [
      { label: "讲座内容", href: "#learn" },
      { label: "接下来会发生什么？", href: "#scenario" },
      { label: "主讲人", href: "#speakers" },
      { label: "常见问题", href: "#faq" },
      { label: "保留席位", href: "#register" },
    ],
    whatsappMessage: "您好，我想询问即将举行的持久授权书（LPA）线上讲座。",
    disclaimer: "Affinity Group 是代表 Infinity Financial Advisory Pte. Ltd. 的财务顾问代表团队。本讲座及网站仅提供一般资讯与教育内容，不构成财务、法律、税务、会计或遗产规划建议，也不构成任何金融产品的要约或推荐。资料可能并不完整或不适合您的个人情况。作出任何决定前，请向具备适当资格的专业人士寻求意见。报名须视席位与最终确认为准。",
    rights: "Affinity Group。保留所有权利。",
  },
  sticky: { mobileTitle: "免费线上讲座", desktopKicker: "下一场直播", reserve: "保留席位", reserveLong: "保留我的免费席位" },
};

export default zh;
